export const USER_AVATAR_COLORS = [
  '#6366F1', '#0EA5E9', '#10B981', '#F59E0B', '#EC4899',
  '#8B5CF6', '#14B8A6', '#F97316', '#E11D48', '#0891B2',
];

export function hashUsername(str) {
  return [...(str || '')].reduce((h, c) => h + c.charCodeAt(0), 0);
}

export function pickAvatarColor(username, usedColors = []) {
  const used = new Set(usedColors.filter(Boolean));
  const available = USER_AVATAR_COLORS.filter(c => !used.has(c));
  const pool = available.length ? available : USER_AVATAR_COLORS;
  return pool[hashUsername(username) % pool.length];
}

export function getUserInitials(username) {
  const cleaned = (username || '').trim();
  if (!cleaned) return '??';
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return cleaned.slice(0, 2).toUpperCase();
}

export function resolveAvatarColor(username, storedColor) {
  return storedColor || pickAvatarColor(username);
}
